import { Box } from "@rebass/grid";
import React, { useState } from "react";

/** Exported so a compact score elsewhere reads in the same gold as the stars. */
export const STAR_FILLED_COLOR = "#FFD700";
const STAR_EMPTY_COLOR = "#E0E0E0";

interface IRatingProps {
  maxStars?: number;
  value: number | null;
  onChange?: (value: number) => void;
  size?: number;
  disabled?: boolean;
  /** Pixels between the stars. Wide enough to aim at by default; a row that
   * only reports a score rather than taking one can pull them together. */
  gap?: number;
}

const StarIcon = ({
  filled,
  size = 20,
}: {
  filled: boolean;
  size?: number;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={filled ? STAR_FILLED_COLOR : STAR_EMPTY_COLOR}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
  </svg>
);

export const Rating: React.FC<IRatingProps> = ({
  maxStars = 5,
  value = 0,
  onChange,
  size = 24,
  disabled = false,
  gap = 4,
}) => {
  const [hoverValue, setHoverValue] = useState<number | null>(null);

  const displayValue = hoverValue !== null ? hoverValue : value || 0;

  return (
    <Box style={{ display: "flex", gap: `${gap}px` }}>
      {[...Array(maxStars)].map((_, i) => {
        const starValue = i + 1;
        return (
          <div
            key={i}
            onMouseEnter={() => !disabled && setHoverValue(starValue)}
            onMouseLeave={() => !disabled && setHoverValue(null)}
            onClick={() => {
              if (!disabled && onChange) {
                onChange(value === starValue ? 0 : starValue);
              }
            }}
            style={{
              cursor: disabled ? "default" : "pointer",
              display: "inline-flex",
            }}
          >
            <StarIcon filled={starValue <= displayValue} size={size} />
          </div>
        );
      })}
    </Box>
  );
};
